import { render, staticRenderFns } from "./contract-qr.vue?vue&type=template&id=13489828&scoped=true"
import script from "./contract-qr.vue?vue&type=script&lang=js"
export * from "./contract-qr.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style-review.css?vue&type=style&index=0&id=13489828&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13489828",
  null
  
)

export default component.exports